import { memo } from 'react';
import cn from 'classnames';
import { SkuExtended } from 'types/sku.types';
import styles from './serviceprice.module.scss';

type ServicePriceBrandedProps = {
  sku: SkuExtended;
  sm?: boolean;
  brandLogo?: string;
  showFixedPrice?: boolean;
};
const ServicePriceBranded = ({ sku, sm, brandLogo, showFixedPrice = false }: ServicePriceBrandedProps) => {
  const baseStyles = cn({ p0: !sm, p1: sm });
  return (
    <>
      <span className={styles.brand}>
        <img src={brandLogo} alt="Brand Logo" className={styles.brandLogo} />
        <p className="caption">Member&apos;s price</p>
      </span>
      <span className={baseStyles}>
        {!showFixedPrice && 'Starting at'} <span className="text-weight-medium">{sku.prices.memberPrice}</span>
      </span>
    </>
  );
};

export default memo(ServicePriceBranded);
